import axios from 'axios'

const DEFAULT_API_BASE_URL = '/'
const API_BASE_URL = (process.env.VUE_APP_API_URL || DEFAULT_API_BASE_URL).replace(/\/+$/, '/')
const AUTH_QUERY_KEYS = ['username', 'password']
const LEGACY_PUBLIC_PATHS = {
  'auth/login': 'xuper_api/loginValid',
  'auth/loginValid': 'xuper_api/loginValid',
  'auth/encodePwd': 'xuper_api/encodePwd',
  'auth/login/getValidateImg': 'xuper_api/getValidateImg',
  'noauth/encodePwd': 'xuper_api/encodePwd',
  'noauth/loginValid': 'xuper_api/loginValid',
  'noauth/getValidateNum': 'xuper_api/getValidateImg'
}

function isBackendRequest(url) {
  if (!url || typeof url !== 'string') return false
  if (!/^https?:\/\//i.test(url)) return true

  try {
    return new URL(url).origin === new URL(API_BASE_URL).origin
  } catch (error) {
    return false
  }
}

function normalizeBackendPath(pathname) {
  const path = pathname.replace(/^\/+/, '')
  if (LEGACY_PUBLIC_PATHS[path]) return LEGACY_PUBLIC_PATHS[path]
  if (path.indexOf('noauth/') === 0) return 'xuper_api/' + path.slice('noauth/'.length)
  if (path.indexOf('auth/') === 0) return 'xuper_auth/' + path.slice('auth/'.length)
  return path
}

// Keep legacy H5 callers working while sending the target API contract.
export function normalizeRequestUrl(url) {
  if (!isBackendRequest(url)) return url

  const absolute = /^https?:\/\//i.test(url)
  let parsed
  try {
    parsed = new URL(url, API_BASE_URL)
  } catch (error) {
    return url
  }

  parsed.pathname = '/' + normalizeBackendPath(parsed.pathname)
  AUTH_QUERY_KEYS.forEach(key => parsed.searchParams.delete(key))

  if (absolute) return parsed.toString()
  return parsed.pathname.replace(/^\/+/, '') + parsed.search
}

export function clearAuthStorage() {
  if (typeof window === 'undefined') return

  const keys = [
    'v_usernm', 'v_telno', 'v_pwd', 'v_telpwd', 'v_telpassword',
    'v_teluser', 'v_telusernm', 'v_telcorpid', 'v_telcorpnm',
    'v_username', 'v_password', 'v_corpnm', 'v_admin', 'v_sys',
    'v_deptnm', 'v_corpid', 'v_idseq', 'lastActiveTime'
  ]
  keys.forEach(key => window.localStorage.removeItem(key))
  if (typeof document !== 'undefined') {
    keys.forEach(key => {
      document.cookie = key + '=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/'
    })
  }
}

const service = axios.create({
  baseURL: API_BASE_URL,
  timeout: 30000,
  withCredentials: true
})

service.interceptors.request.use(
  config => {
    if (config.url) config.url = normalizeRequestUrl(config.url)

    if (config.params && isBackendRequest(config.url)) {
      AUTH_QUERY_KEYS.forEach(key => delete config.params[key])
    }

    if (typeof FormData !== 'undefined' && config.data instanceof FormData) {
      config.headers = config.headers || {}
      config.headers['Content-Type'] = 'multipart/form-data'
    }
    return config
  },
  error => Promise.reject(error)
)

service.interceptors.response.use(
  response => {
    const responseType = response && response.config && response.config.responseType
    if (responseType === 'arraybuffer' || responseType === 'blob') {
      return response
    }

    const body = response && response.data
    if (body && String(body.code) !== '200') {
      if (String(body.code) === '401') {
        clearAuthStorage()
        if (typeof window !== 'undefined') window.location.href = '/login'
      }
      if (String(body.code) === '500' && typeof console !== 'undefined') {
        console.error('服务器内部错误:', body.result || '未知错误')
      }
      if (typeof console !== 'undefined' && body.code !== undefined) {
        console.log(String(body.code) + ':' + (body.result || '请求失败'))
      }
    }
    return body
  },
  error => {
    const status = error && error.response && error.response.status
    if (status === 401) {
      clearAuthStorage()
      if (typeof window !== 'undefined') window.location.href = '/login'
    } else if (status === 500) {
      clearAuthStorage()
      if (typeof window !== 'undefined') {
        if (typeof window.alert === 'function') window.alert('与服务器连接失败，请重新登录')
        window.location.href = '/login'
      }
    }
    return Promise.reject(error)
  }
)

export function unwrapResponse(response) {
  return response
}

export { API_BASE_URL }
export default service
